module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pa-3"
  }, [_c('div', {
    staticClass: "pa-3"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-right",
    attrs: {
      "md12": "",
      "xs12": "",
      "sm12": ""
    }
  }, [_c('v-btn-toggle', {
    attrs: {
      "right": "",
      "mandatory": "",
      "value": 0,
      "light": true
    },
    model: {
      value: (_vm.display),
      callback: function($$v) {
        _vm.display = $$v
      },
      expression: "display"
    }
  }, [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({}, on), [_c('v-icon', [_vm._v("grid_on")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Table View")])]), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({}, on), [_c('v-icon', [_vm._v("mdi-calendar-range")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Calendar View")])])], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.display === 0) ? _c('div', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [(_vm.filteredItems.length > 0) ? _c('div', [_c('report-table', {
    attrs: {
      "headers": _vm.headers,
      "filteredItems": _vm.filteredItems,
      "loading": _vm.loading,
      "refresh": _vm.tableRefresh
    },
    on: {
      "viewInfluencers": _vm.viewInfluencers,
      "updated": _vm.refreshTableView
    }
  })], 1) : _vm._e()])], 1), _vm._v(" "), _c('influencer-modal', {
    attrs: {
      "headers": _vm.influencerHeaders,
      "filteredItems": _vm.filteredInfluencers,
      "filter": _vm.influencerFilter,
      "campaign": _vm.selectedCampaign,
      "overall": _vm.overallTotals,
      "posted": _vm.postedTotals,
      "postedDeliverables": _vm.deliverableTotals,
      "totals": _vm.filterInfTotals,
      "value": _vm.viewInfluencerDialog,
      "loading": _vm.infLoading
    },
    on: {
      "filtered": _vm.filterInfluencerList,
      "dataTableFiltered": _vm.infDataTableFiltered,
      "closed": _vm.closeInfModal
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.display === 1) ? _c('div', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('calendar-table', {
    attrs: {
      "headers": _vm.calendarHeaders,
      "calendarMonths": _vm.showMonths,
      "filteredItems": _vm.filteredCalCampaigns,
      "filter": _vm.calendarFilter,
      "loading": _vm.loading,
      "disableLeftArrow": _vm.disableLeftArrow,
      "disableRightArrow": _vm.disableRightArrow
    },
    on: {
      "filterDate": _vm.filterMonth,
      "changeMonth": _vm.changeMonth
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.loading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "secondary",
      "width.number": "180",
      "height.number": "180"
    },
    on: {
      "update:active": function($event) {
        _vm.loading = $event
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1e554410"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Campaign/AOKReport/index.vue
// module id = 2027
// module chunks = 0